<section tuiContent>
	<p class="mt-0">{{ 'profile.change-password-description' | transloco }}</p>

	@if (error(); as error) {
		<div tuiNotification class="mb-2" size="s" appearance="negative">
			{{ error | transloco }}
		</div>
	}

	@if (form) {
		<form
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
			(keyup.enter)="onSubmit()"
		>
			<label tuiLabel>
				{{ 'data.current-password' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						tuiInput
						formControlName="currentPassword"
						type="password"
						autocomplete="current-password"
					/>
					<tui-icon tuiPassword />
				</tui-textfield>

				<tui-error formControlName="currentPassword" />
			</label>

			<label tuiLabel>
				{{ 'data.new-password' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						tuiInput
						formControlName="password"
						type="password"
						autocomplete="new-password"
					/>
					<tui-icon tuiPassword />
				</tui-textfield>

				<tui-error formControlName="password" />
			</label>

			<label tuiLabel>
				{{ 'data.confirm-password' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						tuiInput
						formControlName="passwordConfirm"
						type="password"
						autocomplete="new-password"
					/>
					<tui-icon tuiPassword />
				</tui-textfield>

				<tui-error formControlName="passwordConfirm" />
			</label>
		</form>
	}
</section>

<footer tuiFooter>
	<button tuiButton appearance="outline" (click)="onDismiss()">
		{{ 'action.cancel' | transloco }}
	</button>
	<button
		tuiButton
		type="submit"
		appearance="accent"
		(click)="onSubmit()"
		[disabled]="busy()"
		[loading]="busy()"
	>
		{{ 'action.save' | transloco }}
	</button>
</footer>
